import { IButtonStyles, IDetailsListStyles, IDropdownStyles, ITextFieldStyles, IStyle, IDetailsHeaderProps, IDetailsHeaderStyles, ICellStyleProps } from "@fluentui/react";

/* ─── Fluent UI style objects matching styles_glob patterns ─── */
export const colorOne = "#56778c";
export const borderColorOne = "#b9daea";
export const stateColors: Record<string, string> = {
    'scheduled':          '#2e7d32',
    'call_initiated':     '#1976d2',
    'complete':           '#56778c',
    'pre-scheduling':     '#8a8a8a',
    'delayed_by_contact': '#e67700',
    'cancelled':          '#c62828',
    'campaign_ended':     '#888',
    'post_analysis':      '#7b1fa2',
    'escalate':           '#d32f2f',
    'retry':              '#f57c00',
};
export const cmDropdownStyles: Partial<IDropdownStyles> = {
    root: { borderRadius: "5px !important", color: colorOne, borderColor: borderColorOne },
    title: {
        fontFamily: "Urbanist", borderRadius: "5px !important", borderColor: borderColorOne + " !important",
        fontSize: "12px", height: "30px",
        selectors: {
            ":focus": { borderRadius: "5px !important", borderColor: borderColorOne + " !important" },
            ":hover": { borderRadius: "5px !important", borderColor: borderColorOne + " !important" },
            "::after": { borderRadius: "5px !important", borderColor: borderColorOne + " !important" }
        }
    },
    dropdown: {
        borderRadius: "5px !important", color: colorOne, borderColor: borderColorOne,
        selectors: {
            ":focus": { borderRadius: "5px !important", borderColor: borderColorOne + " !important" },
            ":hover": { borderRadius: "5px !important", borderColor: borderColorOne + " !important" },
            "::after": { borderRadius: "5px !important", borderColor: borderColorOne + " !important" }
        }
    },
    dropdownItem: { fontFamily: "Urbanist", borderRadius: "5px !important", fontSize: "12px", height: "30px", color: colorOne },
    dropdownItemSelected: { fontFamily: "Urbanist", borderRadius: "5px !important", fontSize: "12px", height: "30px", color: colorOne },
    caretDown: { color: colorOne },
    label: { fontFamily: "Urbanist", fontSize: "13px" }
};

export const cmTextFieldStyles: Partial<ITextFieldStyles> = {
    root: { borderRadius: "5px" },
    fieldGroup: {
        borderRadius: "5px", borderColor: borderColorOne,
        selectors: { "::after": { borderRadius: "5px", border: "2px solid #404040" } }
    },
    subComponentStyles: { label: { root: { fontSize: "13px", fontFamily: "Urbanist" } } }
};

export const cmTextFieldCompactStyles: Partial<ITextFieldStyles> = {
    root: { borderRadius: "5px", alignContent: "space-evenly", verticalAlign: "center" },
    fieldGroup: {
        borderRadius: "5px", borderColor: borderColorOne, verticalAlign: "center",
        selectors: { "::after": { borderRadius: "5px", border: "2px solid #404040" } }
    },
    field: { fontSize: "12px", fontFamily: "Raleway, Urbanist, Roboto",verticalAlign: "center" }
};

export const cmPrimaryButtonStyles: Partial<IButtonStyles> = {
    root: {
        borderRadius: "7px", fontFamily: "Raleway, Urbanist, Roboto",
        transition: "filter 0.2s ease, transform 0.1s ease",
        boxShadow: "rgba(50, 50, 93, 0.15) 0px 4px 12px -4px"
    },
    rootHovered: {
        selectors: {
            "&:not(.is-disabled)": { filter: "brightness(110%)", transition: "filter 0.2s ease" },
            "&:not(.is-disabled):hover": { filter: "brightness(115%)" }
        }
    }
};

export const cmDefaultButtonStyles: Partial<IButtonStyles> = {
    root: { borderRadius: "5px", fontFamily: "Urbanist", transition: "transform 0.1s ease-in-out" },
    rootHovered: { selectors: { ":hover": { transform: "scale(1.02)" } } }
};

export const cmSmallPrimaryStyles: Partial<IButtonStyles> = {
    root: { borderRadius: "5px", height: "28px", minWidth: "50px", fontFamily: "Urbanist", fontSize: "12px", padding: "0 10px" }
};

export const cmSmallDefaultStyles: Partial<IButtonStyles> = {
    root: { borderRadius: "5px", height: "28px", minWidth: "50px", fontFamily: "Urbanist", fontSize: "12px", padding: "0 10px" }
};


export const detailsListCampaignStyles: Partial<IDetailsListStyles> = {
    root: {borderRadius: "5px",   padding: "0px !important", margin: "0px !important",},
    headerWrapper: { padding: "0px !important", margin: "0px !important", },
    contentWrapper: { padding: "0px !important", margin: "0px !important" },
}

export const controlDetailsListMainStyles = {
    root: {
        margin: "0",
        padding: "0px !important",
        width: "auto"
    },
    commandButton: {
        padding: "0px !important",
    },
    headerWrapper: {
        position: "sticky",
        top: 0,
        zIndex: 1
    } as IStyle,
    detailsHeader: {
        padding: "0px"
    },

};

export const orderHeaderCampaignCustomStyles: Partial<IDetailsHeaderStyles> = {
    root: {
        padding: "0px !important",
        margin: "0px !important",
        font: "normal normal 13px/40px Urbanist,Roboto !important",
        fontFamily: "Urbanist, Roboto",
        cursor: "pointer",
        position: "sticky",
        top: 0,
        zIndex: 100,
        backgroundColor: "#fff",
        borderBottom: "1px solid #ddd"
    },
    check: {
        padding: "0px !important",
        margin: "0px !important",
        fontFamily: "Urbanist, Roboto !important",
    },
};

